import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
	selector: 'app-cms-badge',
	imports: [CommonModule],
	standalone: true,
	templateUrl: './cms-badge.html',
	styleUrl: './cms-badge.scss',
})
export class CmsBadge {
	color = input<string>();
}
